<div class="container">
  <img src="https://indylogix.com/wp-content/uploads/2020/10/hire-angular-developer-indylogix-solutions.png" alt="">
</div>
